import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";


export interface ILocalizationModuleInitData {
    cultureInfo: any;
    priceToDecimalDivisor: number;
    selectedLanguage: string;
    selectedLanguageId: number;
}

//Refactor this should definitely not be a module
@ModuleName("LocalizationModule")
export class LocalizationModule implements AxInit {
    private cultureInfo: any;
    private priceToDecimalDivisor: number;
    private selectedLanguage: string;
    private selectedLanguageId: number;

    AxInit(init: ILocalizationModuleInitData): void {
        this.cultureInfo = init.cultureInfo;
        this.priceToDecimalDivisor = init.priceToDecimalDivisor;
        this.selectedLanguage = init.selectedLanguage;
        this.selectedLanguageId = init.selectedLanguageId;
    }

    getSelectedLanguage(): string {
        return this.selectedLanguage;
    }

    getSelectedLanguageId(): number {
        return this.selectedLanguageId;
    }

    getCultureInfo(): any {
        return this.cultureInfo;
    }

    getPriceToDecimalDivisor(): number {
        return this.priceToDecimalDivisor;
    }
}